import request from '@/utils/request'

// 查询用户提现记录列表
export function listWithdrawalRecord(query) {
  return request({
    url: '/withdrawal/withdrawal/record/list',
    method: 'get',
    params: query
  })
}

// 查询用户提现记录详细
export function getWithdrawalRecord(id) {
  return request({
    url: '/withdrawal/withdrawal/record/' + id,
    method: 'get'
  })
}

// 新增用户提现记录
export function addWithdrawalRecord(data) {
  return request({
    url: '/withdrawal/withdrawal/record',
    method: 'post',
    data: data
  })
}

// 修改用户提现记录
export function updateWithdrawalRecord(data) {
  return request({
    url: '/withdrawal/withdrawal/record',
    method: 'put',
    data: data
  })
}

// 删除用户提现记录
export function delWithdrawalRecord(id) {
  return request({
    url: '/withdrawal/withdrawal/record/' + id,
    method: 'delete'
  })
}
